import { createAction, props } from '@ngrx/store';
import { Exercise as ExercisePagination } from '@tekman/onmat/component/activities';
import {
  Activity,
  ActivityStudentAnswers,
  ActivityStudentAverage,
  AverageGrade,
  CheckboxItemNode,
  EvaluationPage,
  Feature,
  Grades,
  GroupEvaluationStatus,
  Materials,
  Rubric,
  RubricsAnswers,
  StudentsGroup,
  StudentSubcompetences,
  SubCompetencesAssessmentStudents,
  Tags,
  TeachingInfo,
  UpdatedActivityFeature,
  StepsCategoryModel,
  ErrorModel,
} from '@tekman/onmat/models';

export const teacherRouterSuccess = createAction('[Router] Router Teacher Success', props<{ id: string }>());

export const loadTeacherActivitySuccess = createAction('[Activities/API] Load Activity Teacher Success', props<{ activity: Activity }>());
export const loadTeacherActivityFailure = createAction('[Activities/API] Load Activities Teacher Failure', props<{ error: ErrorModel }>());

export const loadTeacherActivityRubricsSuccess = createAction(
  '[Activities/API Rubrics] Load Rubrics Teacher Success',
  props<{ rubrics: Rubric[] }>()
);
export const loadTeacherActivityRubricsFailure = createAction(
  '[Activities/API] Load Rubrics Teacher Failure',
  props<{ error: ErrorModel }>()
);

export const loadTeacherStepsSuccess = createAction('[Activities/API] Load Steps Teacher Success', props<{ steps: StepsCategoryModel }>());
export const loadTeacherStepsFailure = createAction('[Activities/API] Load Steps Teacher Failure', props<{ error: ErrorModel }>());

export const loadTeacherTagsSuccess = createAction('[Activities/API] Load Tags Teacher Success', props<{ tags: Tags[] }>());
export const loadTeacherTagsFailure = createAction('[Activities/API] Load Tags Teacher Failure', props<{ error: ErrorModel }>());

export const addTeacherFeatures = createAction('[Activities/Configuration] Add Teacher Features', props<{ features: Feature[] }>());

export const loadEvaluationPages = createAction(
  '[Activity/Evaluation] Load evaluation pages',
  props<{ activity: Activity; features: Feature[] }>()
);

export const loadEvaluationPagesFailure = createAction('[Api/Evaluation] Load evaluation pages Failure', props<{ error: ErrorModel }>());

export const loadTeachingInfoSuccess = createAction(
  '[Activities/Configuration] Load Teaching Info Success',
  props<{ teachingInfo: TeachingInfo }>()
);
export const loadTeachingInfoFailure = createAction(
  '[Activities/Configuration] Load Teaching Info Failure',
  props<{ error: ErrorModel }>()
);

export const saveAverageGradesSuccess = createAction(
  '[Activities/API] Save student Average Grades Success',
  props<{ averageGrades: AverageGrade[] }>()
);
export const saveAverageGradesFailure = createAction(
  '[Activities/API] Save student Average Grades Failure',
  props<{ error: ErrorModel }>()
);

export const loadSubcompetencesAssessmentStudents = createAction(
  '[Rubrics/API] Load Subcompetences Assessment Students',
  props<{ activity: string; teams: CheckboxItemNode[] }>()
);

export const loadEvaluationStudentSubcompetenceStatusSuccess = createAction(
  '[Activities/API] Load Students Evaluation Subcompetence Status Success',
  props<{ groupEvaluationSubcompetenceStatus: GroupEvaluationStatus }>()
);
export const loadEvaluationStudentSubcompetenceStatusFailure = createAction(
  '[Activities/API] Load Students Evaluation Subcompetence Status Failure',
  props<{ error: ErrorModel }>()
);

export const applySubcompetencesAssessmentStudents = createAction(
  '[Rubrics/API] Apply Subcompetences Assessment Students',
  props<{
    activity: Activity;
    subcompetencesAssessmentStudents: SubCompetencesAssessmentStudents;
    teams: CheckboxItemNode[];
    studentsGroup: StudentsGroup[];
  }>()
);

export const applySubcompetencesAssessmentStudentsFailure = createAction(
  '[Rubrics/API] Apply Subcompetences Assessment Students Failure',
  props<{ error: ErrorModel }>()
);

export const autoSaveEvaluationGrades = createAction(
  '[Activity Evaluation] AutoSave Subcompetences Assessment Student',
  props<{
    activity: Activity;
    subcompetencesAssessmentStudent: StudentSubcompetences;
    teams: CheckboxItemNode[];
    studentsGroup: GroupEvaluationStatus;
    selectedStudent: string;
  }>()
);

export const publishMarks = createAction(
  '[Activities/Evaluation] Send grades Evaluation',
  props<{
    activity: Activity;
    subcompetencesAssessmentStudent: StudentSubcompetences;
    groupEvaluation: GroupEvaluationStatus;
    studentId: string;
  }>()
);
export const unPublishMarks = createAction(
  '[Activities/Evaluation] Remove grades Evaluation',
  props<{
    activity: Activity;
    subcompetencesAssessmentStudent: StudentSubcompetences;
    groupEvaluation: GroupEvaluationStatus;
    studentId: string;
  }>()
);

export const updateStudent = createAction(
  '[Activities/Evaluation] Post grades Evaluation',
  props<{ status: number; selectedStudent: string; grades: Grades[] }>()
);

export const loadTeacherGuide = createAction('[Activities/API] Get Teacher Guide', props<{ activity: Activity; exerciseId: string }>());
export const loadTeacherGuideSuccess = createAction(
  '[Activities/API] Get Teacher Guide Success',
  props<{ exerciseId: string; teacherGuide: string }>()
);
export const loadTeacherGuideFailure = createAction('[Activities/API] Get Teacher Guide Failure', props<{ error: ErrorModel }>());

export const loadTeacherSolutionary = createAction(
  '[Activities/API] Get Teacher Solutionary',
  props<{ activity: Activity; exerciseId: string }>()
);
export const loadSolutionarySuccess = createAction(
  '[Activities/API] Get Solutionary Success',
  props<{ exerciseId: string; solutionary: string }>()
);
export const loadSolutionaryFailure = createAction('[Activities/API] Get Solutionary Failure', props<{ error: ErrorModel }>());

export const saveEvaluationPages = createAction(
  '[Api/Evaluation] Save evaluation pages',
  props<{ activity: Activity; exercise: ExercisePagination }>()
);
export const saveEvaluationPagesSuccess = createAction(
  '[Api/Evaluation] Save evaluation pages Success',
  props<{ evaluationPage: EvaluationPage }>()
);
export const saveEvaluationPagesFailure = createAction('[Api/Evaluation] Save evaluation pages Failure', props<{ error: ErrorModel }>());

export const repeatActivity = createAction(
  '[Activities/Evaluation] Repeat Activity',
  props<{ activity: Activity; selectedStudent: string }>()
);
export const repeatActivitySuccess = createAction(
  '[Activities/Evaluation] Effect Success Repeat Activity',
  props<{ selectedStudent: string; status: number }>()
);
export const repeatActivityFailure = createAction('[Activities/Evaluation] Repeat Activity Failure', props<{ error: ErrorModel }>());

export const loadStudentMultianswersSuccess = createAction(
  '[Activities/API] Load student multianswers Success',
  props<{ activityId: string; studentId: string }>()
);
export const loadStudentMultianswersFailure = createAction(
  '[Activities/API] Load student multianswers Failure',
  props<{ error: ErrorModel }>()
);

export const loadStudentAnswersAPracticar = createAction('[Rubrics] LoadStudentAnswers');
export const loadStudentAnswersAPracticarSuccess = createAction(
  '[Rubrics/API] Load Rubrics Answers Success',
  props<{ rubricsMultiChoice: RubricsAnswers }>()
);
export const loadStudentAnswersAPracticarFailure = createAction(
  '[Rubrics/API] Load Rubrics Answers Failure',
  props<{ error: ErrorModel }>()
);

export const saveFeature = createAction(
  '[Activities/Configuration] Save Feature',
  props<{ activity: Activity; selectedGroupId: string; feature: UpdatedActivityFeature; features: Feature[]; studentId: string }>()
);
export const saveFeatureSuccess = createAction('[Activities/Configuration] Add Features', props<{ features: Feature[] }>());
export const saveFeatureFailure = createAction('[Activities/Configuration] Save Feature Failure', props<{ error: ErrorModel }>());

export const loadActivityMaterials = createAction('[Activities/API] Load Activity Materials', props<{ activity: Activity }>());
export const loadActivityMaterialsSuccess = createAction(
  '[Activities/API] Load Activity Materials Success',
  props<{ materials: Materials }>()
);
export const loadActivityMaterialsFailure = createAction('[Activities/API] Materials load Failure', props<{ error: ErrorModel }>());

export const loadActivityStudentAnswers = createAction(
  '[Activities/API] Load Activity Student Answer Evaluation',
  props<{ activity: Activity; studentId: string; status: number }>()
);
export const loadActivityStudentAnswersSuccess = createAction(
  '[Activities/API] LoadStudentAnswers Success',
  props<{ activity: Activity; answers: ActivityStudentAnswers[]; averages: ActivityStudentAverage }>()
);
export const loadActivityStudentAnswersFailure = createAction('[Activities/API] Materials load Failure', props<{ error: ErrorModel }>());

export const modifyFeatureSuccess = createAction(
  '[Activities/Configuration] Modify Feature',
  props<{ activityId: string; featureName: string; value: boolean }>()
);

export const clearActivity = createAction('[Activities] Clear Activity');
